import {
  TDeleteRoundInfoFormValues,
  TRegisterRoundInfoFormValues,
} from 'types/form/professor';

export const RegisterRoundDefaultValues: TRegisterRoundInfoFormValues = {
  courseInfoId: null,
  chartRound: null,
  chartName: '',
  chartTypeList: [],
  firstSubmitStartDate: '',
  firstSubmitEndDate: '',
  secondSubmitStartDate: '',
  secondSubmitEndDate: '',
};

export const DeleteRoundDefaultValues: TDeleteRoundInfoFormValues = {
  password: '',
};
